<div class="dashletActivity">
  <img
    class="dashletActivity__icon dashletActivity__icon--narrow"
    [src]="EIconPath.BASIC_FIELD_COMMENT"
    />

  <div class="dashletActivity__text">
    @switch (ppChange.propName) {
      @case ('pointCopyTo') {
        {{ 'copied_this_point_from' | ppTranslate }}
        <span class="dashletActivities__item-quoted">{{ ppChange.oldValue }}.</span>
      }
      @case ('pointCopyFrom') {
        {{ 'copied_this_point_to' | ppTranslate }}
        <span class="dashletActivities__item-quoted">{{ ppChange.newValue }}.</span>
      }
      @default {
        {{ 'copied_this_point_to' | ppTranslate }}
        <span class="dashletActivities__item-quoted">{{ ppChange.newValue }}.</span>
      }
    }
  </div>
</div>
